var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmittedPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4663_54238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2857 8C15.4286 8 9 14.4286 9 22.2857C9 26 10.4286 29.7143 13.1429 32.4286L22.2857 41.8571C22.8571 42.4286 23.7143 42.4286 24.2857 41.8571L33.2857 32.4286C36.1429 29.7143 37.5714 26.1429 37.5714 22.2857C37.5714 14.4286 31.1429 8 23.2857 8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2861 7.25C31.5573 7.25023 38.3213 14.0149 38.3213 22.2861C38.3212 26.3369 36.8171 30.1089 33.8027 32.9727L24.8281 42.375L24.8223 42.3809L24.8164 42.3877C23.9522 43.2519 22.6202 43.2517 21.7559 42.3877L21.7471 42.3789L12.6123 32.958C9.74996 30.0954 8.25011 26.1875 8.25 22.2861C8.25 14.0148 15.0148 7.25 23.2861 7.25Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4663_54238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2428 22.8633H22.757C22.6573 22.8633 22.5762 22.9444 22.5762 23.0441V24.5365C22.5762 24.6362 22.6573 24.7174 22.757 24.7174H24.2428C24.3425 24.7174 24.4236 24.6362 24.4236 24.5365V23.0441C24.4236 22.9444 24.3425 22.8633 24.2428 22.8633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7231 16.7611H26.6587V15.4788C26.6587 14.8088 26.1084 14.2637 25.4319 14.2637H21.5681C20.8916 14.2637 20.3413 14.8088 20.3413 15.4788V16.7611H17.2769C15.7457 16.7611 14.5 18.0068 14.5 19.538V21.2023C14.6031 21.7042 14.9655 22.1174 15.467 22.2779L21.5184 23.7568V23.0436C21.5184 22.3606 22.0741 21.8049 22.7571 21.8049H24.2429C24.9259 21.8049 25.4816 22.3606 25.4816 23.0436V23.7568L31.533 22.2779C32.0345 22.1174 32.3969 21.7042 32.5 21.2023V19.538C32.5 18.0068 31.2543 16.7611 29.7231 16.7611ZM25.6008 16.7611H21.3992V15.4788C21.3992 15.3892 21.4718 15.3216 21.5681 15.3216H25.4319C25.5282 15.3216 25.6008 15.3892 25.6008 15.4788V16.7611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8314 23.2938C31.8212 23.2969 31.811 23.2998 31.8008 23.3022L25.4394 24.8569C25.298 25.3853 24.8152 25.7755 24.2429 25.7755H22.7571C22.1848 25.7755 21.702 25.3853 21.5606 24.8569L15.1992 23.3022C15.189 23.2997 15.1788 23.2969 15.1686 23.2938C14.9257 23.2188 14.7016 23.1094 14.5 22.9727V27.4689C14.5 28.7196 15.5175 29.7372 16.7683 29.7372H30.2317C31.4824 29.7372 32.5 28.7196 32.5 27.4689V22.9727C32.2984 23.1094 32.0743 23.2188 31.8314 23.2938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4663_54238",
    x: 0.7,
    y: 0.7,
    width: 45.1713,
    height: 50.8852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4663_54238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4663_54238",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4663_54238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(14.5 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedPinIcon);
export default __webpack_public_path__ + "static/media/SubmittedPinIcon.e3a1a7a0b7e02c135cc626af18ff8787.svg";
export { ForwardRef as ReactComponent };